import React from 'react';

interface Props {
  value: any;
  delay?: number;
}

const DELAY_TIME = 500;

export const useDebounce = ({ value, delay = DELAY_TIME }: Props) => {
  const [debouceValue, setDebouceValue] = React.useState('');

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouceValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouceValue;
};
